import { setCookie, getCookie } from './cookies';

const $recentHolder = $('.section--recent .collection__items');
let visitedPages = [];

const productTemplate = `
    <div class="product-item animations" data-animation="fadeIn">
      <form method="post" action="/cart/add" id="product_form_{{id}}" accept-charset="UTF-8" class="product-item__inner" enctype="multipart/form-data"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
        <a href="{{href}}" class="product-item__image">
          <img src="{{src}}">

          {{icons}}
        </a>

        <h4 class="product-item__title">
          <a href="{{href}}">{{title}}</a>
        </h4>

        <p class="product-item__sku">
          {{sku}}
        </p><!-- /.product-item__sku -->

        <p class="product-item__price">
          ${Shopify.theme.locale.products.item.price_prefix}
          <ins class="price__amount">
            <span class="money">
              {{money}}
            </span>
          </ins>

          <del class="price__amount">
            <span class="money">
              {{compareMoney}}
            </span>
          </del>
        </p>

        <div class="product-item__add">
          <p class="product-item__info">
            {{info}}
          </p><!-- /.product-item__info -->

          <select name="id" id="product-select" class="hidden">
            <option selected value="{{select}}"></option>
          </select>

          <button type="submit" name="add" class="btn product-item__btn">
            {{btn}}
          </button>
        </div><!-- /.product-item__add -->
      </form><!-- /.product-item__inner -->
    </div>
`;

function getProduct(arr) {
  arr.map(item => {
    $.ajax({
      url: `/products/${item}.js`,
      dataType: 'json'
    }).done(response => {
      let markup = productTemplate;
      let title = response.title.length > 45 ? $.trim(response.title).substring(0, 45) + '...' : response.title;

      markup = markup.replace('{{id}}', response.id);
      markup = markup.replace('{{src}}', response.featured_image);
      markup = markup.replace('{{title}}', title);
      markup = markup.replace('{{sku}}', Shopify.theme.locale.products.item.sku_prefix + response.variants[0].sku);
      markup = markup.replace(/{{href}}/g, `/products/${item}`);
      markup = markup.replace('{{money}}', Shopify.formatMoney(response.price));
      markup = markup.replace('{{info}}', response.body_html ? response.body_html : '');
      markup = markup.replace('{{btn}}', Shopify.theme.locale.products.product.add_to_cart);
      markup = markup.replace('{{select}}', response.variants[0].id);

      if (response.compare_at_price) {
        markup = markup.replace('{{compareMoney}}', Shopify.formatMoney(response.compare_at_price));
      } else {
        markup = $(markup)
          .find('del.price__amount')
          .remove()
          .end()[0].outerHTML;

        markup = markup.replace('ins', 'span');
      }

      if (response.tags.length) {
        let tagsArr = response.tags.filter(tag => tag.indexOf('attr_') !== -1);
        let tagsArrLen = tagsArr.length;
        let iconsMarkup = '';

        if (tagsArrLen > 1) {
          markup = markup.replace('class="product-item', 'class="product-item product-item--icons-only');
        }

        $.each(tagsArr, function(index, value) {
          if (index === 0) {
            iconsMarkup += `<span class="product-item__icons">
            `;
          }

          iconsMarkup += `<p class="product-item__${value}"></p>`;

          if (index === tagsArrLen - 1) {
            iconsMarkup += '</span>';
          }
        });

        markup = markup.replace('{{icons}}', iconsMarkup);
      } else {
        markup = markup.replace('{{icons}}', '');
      }

      $recentHolder.append(markup);
    });
  });
}

if (getCookie('visitedPages')) {
  visitedPages = getCookie('visitedPages').split(',');
  $recentHolder.empty();
  getProduct(visitedPages);
} else {
  $recentHolder
    .hide()
    .next()
    .show();
}

if ($('body').hasClass('template-product')) {
  let productURL = window.location.pathname;
  let productHandle = productURL.split('/products/')[1];

  if (visitedPages.indexOf(productHandle) < 0) {
    visitedPages.push(productHandle);
  }

  let visitedPagesLen = visitedPages.length;
  if (visitedPagesLen > 6) {
    visitedPages = visitedPages.slice(visitedPagesLen - 6, visitedPagesLen);
  }

  setCookie('visitedPages', visitedPages.join(','), 99);
}



// WEBPACK FOOTER //
// ../assets/js/recently-view.js